import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'geec-outdated-browser',
  templateUrl: './outdated-browser.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OutdatedBrowserComponent {

}
